export const STORAGE_KEY = "onboarding";
export const ANDROID_OBESITY_STORE_PAGE_URL =
  "https://play.google.com/store/apps/details?id=se.accumbo.app01&listing=weight-loss";
export const IOS_OBESITY_STORE_PAGE_URL =
  "https://apps.apple.com/us/app/blodtrycksdoktorn/id1370371435?ppid=3ebaf2cc-9c2a-4ccd-a08a-adf69c3f5523";
export const QUERY_PARAM_WHITELIST = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term",
];
export const MIN_HEIGHT_CM = 100;
export const MAX_HEIGHT_CM = 220;
export const MIN_WEIGHT_KG = 40;
export const MAX_WEIGHT_KG = 250;
